import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef,
ComponentFactoryResolver, ViewContainerRef, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Account } from '@mitel/cloudlink-sdk';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, Subject, EMPTY } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, startWith, skip } from 'rxjs/operators';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import * as _ from 'lodash';
import { MatButton } from '@angular/material/button';

export class ComponentFilterItem 
{
  service: any;
  component: any;
  instance: any;
}

export class GenericFilterMenu {
  displayStr: string;
  phraseStr: string;
  id: string;
  prerequisite?: string; // The id of another filter that must be present for this filter to be valid
  componentBased?: ComponentFilterItem;
  multipleSelection?: boolean;
  submenu?: GenericFilterMenu[];
  data?: any;
  incompatibleWith?: string; // The id of another filter that is incompatible with this filter
  hasInputMenuItems?: boolean;
}

export class GenericItemSearchConfig {
  textSearch: boolean;
  textSearchPlaceholder?: string;
  filterSearch: boolean;
  filterConfig?: GenericFilterMenu[];
}

export class GenericItemSearchParams {
  searchText: string;
  filterData: any[];
}

export class FilterItem {
  id: string;
  topicDisplayStr: string;
  valueStr: string[];
  data: any;
  originalItem: GenericFilterMenu;
}

@Component({
  selector: 'app-generic-item-search-controls',
  templateUrl: './generic-item-search-controls.component.html',
  styleUrls: ['./generic-item-search-controls.component.scss']
})

export class GenericItemSearchControlsComponent implements OnInit, OnDestroy, OnChanges{
  @Input() account: Account;
  @Input() config: GenericItemSearchConfig;
  /** String to be used as data-e2e attribute */
  @Input('e2eTag') e2eTag: string;
  @Output() searchParamsChange : EventEmitter<GenericItemSearchParams> = new EventEmitter();

  @ViewChild('filterComponent', {read: ViewContainerRef}) filterComponent: ViewContainerRef;
  @ViewChild('filterMenuTrigger') filterMenuTrigger: MatMenuTrigger;
  @ViewChild('menu') filterMenu: MatMenu;
  @ViewChild('addFilterButton') addFilterButton: MatButton;
  @ViewChild('removeInProgressFilterButton') removeInProgressFilterButton: MatButton;

  selectedFilterParams: GenericItemSearchParams = undefined;
  selectedFilters: FilterItem[] = [];
  availableFilters: GenericFilterMenu[] = [];
  currentMenu: GenericFilterMenu;
  baseFilters:  GenericFilterMenu[] = [];
  originatingMenu: GenericFilterMenu;
  filterInProgress: FilterItem = undefined;
  showMenu: boolean = true;
  $searchTerm = new Subject<string>();
  searchTerm: string;
  textSearchDisabled: boolean = false;
  subscription: Subscription = new Subscription();
  searchParams: GenericItemSearchParams = new GenericItemSearchParams();
  componentEventSub: Subscription;
  
  constructor(
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private CFR: ComponentFactoryResolver,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translateService: TranslateService,
    private spinnerService: SpinnerService
  ) 
  {
	  this.matIconRegistry.addSvgIcon(
		  'search_app',
		  this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/search-big.svg")
	  );

    this.matIconRegistry.addSvgIcon(
		  'circle_plus',
		  this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/circle_plus.svg")
	  );

    this.matIconRegistry.addSvgIcon(
		  'remove_x',
		  this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/cross-error.svg")
	  );
  }

  async ngOnInit() {
    
    await this.createAvailableFiltersList();

    this.subscription.add(this.$searchTerm.pipe(
      debounceTime(1000),
      startWith(''),
      distinctUntilChanged(),
      skip(1),
      switchMap( async term => {
        this.searchParams.searchText = term.length > 0 ? term : undefined;
        this.searchParamsChange.emit(this.searchParams);
        return EMPTY;
      })
      ).subscribe()
		);

    this.subscription.add(this.filterMenu.closed.subscribe((menuCloseReason) => {
      let button = this.filterInProgress ? this.removeInProgressFilterButton : this.addFilterButton;
      // focus the button when the menu closes
      button.focus();
      if (!menuCloseReason || menuCloseReason == 'click') {
        // blur the button if the menu was closed by a click (click means selection, not mouseclick)
        button._elementRef.nativeElement.blur();
      }
    }));
  }

  async ngOnChanges( change: SimpleChanges )
  {
    if ( change.config )
    {
      this.config = change.config.currentValue;
      this.clearSearchParameters();
    }
    if ( change.account )
    {
      this.account = change.account.currentValue;
      this.clearSearchParameters();
    }
  }

  // for now we will clear existing parameters
  // they might want use to save them on change in the future
  async clearSearchParameters()
  {
    this.selectedFilters = [];
    this.searchParams.searchText = undefined;
    this.searchParams.filterData = undefined;
    await this.createAvailableFiltersList();
  }

  // debatable whether this is needed
  // might be removed in the future
	/* istanbul ignore next */ 
  isTabbable()
  {
    return true;
  }

  showTheComponentFilter( item: GenericFilterMenu)
  {
    console.log("show the component filter", item)
    let filterData = this.generateFilterData(this.selectedFilters);
    let componentFactory = this.CFR.resolveComponentFactory( item.componentBased.component );
    let childComponentRef = this.filterComponent.createComponent( componentFactory );
    item.componentBased.instance = childComponentRef.instance;
    item.componentBased.service.initAuxFilterComponent( this.account, item.componentBased.instance, filterData );
    let emitResultEvent = item.componentBased.service.getAuxFilterChangeEvent( item.componentBased.instance )
 console.log("The event", emitResultEvent)
    if ( emitResultEvent != null )
    {
      this.componentEventSub = emitResultEvent.subscribe( async event => {
        console.log("Received the EMIT event", event)
        if ( this.componentEventSub )
          this.componentEventSub.unsubscribe();
        this.componentEventSub = undefined;
 
        if ( this.filterInProgress == undefined )
        {
          // filter is complete, create a bubble
          this.filterInProgress = new FilterItem();
          this.filterInProgress.topicDisplayStr = this.currentMenu.displayStr;
          this.filterInProgress.originalItem = item;
          this.filterInProgress.id = item.id;
        }
        this.filterInProgress.originalItem = item; // id changes to the actual filter
        this.filterInProgress.id = event.id;
        this.filterInProgress.valueStr = new Array<string>();
        this.filterInProgress.valueStr.push( event.displayStr );
        this.filterInProgress.data = event.data;
        this.selectedFilters.push(this.filterInProgress);
        this.filterComponent.remove(0);
        this.currentMenu = undefined;
        this.filterInProgress = undefined;
        // here we reset the filters to the beginning
        // remove any menus that can only be selected once
        await this.resetAvailableFilters();
        this.createFilterParamsAndEmit();
      });
    }
  }

  async createAvailableFiltersList()
  {
    this.currentMenu = undefined;
    if ( this.config && this.config.filterSearch == true && this.config.filterConfig )
    {
      this.baseFilters = this.config.filterConfig;
      this.originatingMenu = undefined;
      this.currentMenu = undefined;
      await this.resetAvailableFilters();
    }
  }
    
  // debatable whether this is needed - using for tabbing experiments
  // might be removed in the future
	/* istanbul ignore next */ 
  onMenuOpened()
  {
    console.log("The menu was opened")
   // setTimeout(() => this.filterComponent.element.nativeElement.focus());
  }

  // debatable whether this is needed - using for tabbing experiments
  // might be removed in the future
	/* istanbul ignore next */ 
  onAddFilter()
  {
    console.log("In onAddFilter to open the menu")
    this.filterMenuTrigger.openMenu();
  }

  // create initial Filter in progress
  createInitialFilterInProgress( item: GenericFilterMenu )
  {
    this.originatingMenu = item;
    let newFilter = new FilterItem();
    newFilter.topicDisplayStr =  item.displayStr;
    newFilter.originalItem = item;
    newFilter.id = item.id;
    this.filterInProgress = newFilter;
  }

  async onClickMenuFilter( item: GenericFilterMenu )
  {
    if ( item == undefined )
      return;

    // user picked a menu item that has a submenu
    // this is a start of a new filter in progress
    // show the submenu
    if ( item.submenu )
    {
      this.createInitialFilterInProgress( item );
      setTimeout( () =>{
        this.showMenu = true;
        this.currentMenu = item;
        this.availableFilters = item.submenu;
        this.filterMenuTrigger.openMenu();
      }, 200) // to prevent an annoying flash of the second menu

    }
    // The user picked a menu item that is component based (aka customer component)
    // create a new filter in progress and open the menu with the custom component
    else if ( item.componentBased )
    {
      this.showMenu = false;
      this.createInitialFilterInProgress( item );

      setTimeout( () =>{
        this.currentMenu = item;
        this.availableFilters = [];
        // now show the custom component
        this.showTheComponentFilter(item);
        this.filterMenuTrigger.openMenu();
      }, 200) // to prevent an annoying flash of the second menu
    }
    // the user has completed selecting a filter that is not component based
    // complete the filter and initialize the filter menus
    else if ( item && item.submenu == undefined && item.componentBased == undefined )
    {
      if ( this.filterInProgress == undefined )
      {
        // filter is complete, create a bubble
        this.filterInProgress = new FilterItem();
        this.filterInProgress.topicDisplayStr =  this.currentMenu.displayStr;
      }
      this.filterInProgress.originalItem = item; // id changes to the actual filter
      this.filterInProgress.id = item.id;
      this.filterInProgress.valueStr = new Array<string>();
      this.filterInProgress.valueStr.push( this.translateService.instant( item.displayStr ) );
      this.filterInProgress.data = item.data;
      this.selectedFilters.push(this.filterInProgress);

      this.currentMenu = undefined;
      this.filterInProgress = undefined;
      // here we reset the filters to the beginning
      // remove any menus that can only be selected once
      await this.resetAvailableFilters();
      this.checkIfSearchIsAllowed();
      this.createFilterParamsAndEmit();
    }
  }

  onClickInputMenuFilter(item) {
    item.displayStr = item.data.control.value;
    item.data.value = item.data.control.value;
    this.onClickMenuFilter(item);
  }

  // the Add Filter link is only shown if there are available filters OR there is
  // a filter building in progress
  showAddFilter()
  {
    if ( (this.availableFilters && this.availableFilters.length > 0) ||
        this.filterInProgress != undefined )
    {
      return true;
    }
    return false;
  }

  async resetAvailableFilters()
  {
    this.availableFilters = new Array<GenericFilterMenu>();
    //  the menu will only contain menus that are still available to be selected

    // create the list of filter data incase it is to be tested 
    let filterData = this.generateFilterData(this.selectedFilters);

    for ( var i = 0; i < this.baseFilters.length; i++ )
    {
      let stillValid = true;
      let submenuFilter = Array<number>(); // could be many submenus selected

      // does it have a prerequesite? 
      if ( this.baseFilters[i].prerequisite )
      {
        // this filter is only valid if its prerequesite has been selected
        let foundFilter = this.selectedFilters.find( item => {
          return this.baseFilters[i].prerequisite == item.originalItem.id;
        });
        if ( !foundFilter )
        {
          stillValid = false;
        }
      }
      // is it incompatible with a selected filter? 
      if ( this.selectedFilters && this.selectedFilters.length > 0 && this.baseFilters[i].incompatibleWith && this.baseFilters[i].incompatibleWith.length > 0 )
        {
          // this filter is only valid if its incompatible filters have not been selected
          let foundFilter = this.selectedFilters.find( item => this.baseFilters[i].incompatibleWith == item.originalItem.data.type );
          if ( foundFilter )
          {
            stillValid = false;
          }
        }
      if ( stillValid )
      {
        if ( this.baseFilters[i].componentBased && this.baseFilters[i].componentBased.service.isComponentStillValid )
        {
          let componentStillValid = 
            await this.baseFilters[i].componentBased.service.isComponentStillValid(this.account, filterData);
          stillValid = componentStillValid;
        }
          for ( var j = 0; j < this.selectedFilters.length && stillValid; j++ )
          {
            if ( this.baseFilters[i].submenu == undefined && 
              this.selectedFilters[j].originalItem.id == this.baseFilters[i].id &&
              ( this.baseFilters[i].multipleSelection == undefined || this.baseFilters[i].multipleSelection == false )) 
            {
              stillValid = false;
            }
            else if ( this.baseFilters[i].submenu != undefined )// the selected filter is on the submenu
            {
              for ( var k = 0; k < this.baseFilters[i].submenu.length && stillValid; k++ )
              {
                if ( this.selectedFilters[j].originalItem.id == this.baseFilters[i].submenu[k].id &&
                  ( this.baseFilters[i].submenu[k].multipleSelection == undefined || this.baseFilters[i].submenu[k].multipleSelection == false )) 
                {
                  if ( this.baseFilters[i].multipleSelection == undefined || this.baseFilters[i].multipleSelection == false ) 
                  {
                    // match is at the submenu level but the topic can not be selected again
                    stillValid = false;
                  }
                  else if ( this.baseFilters[i].submenu.length > 1 ) // if you just selected the last filter, there is no more filter
                  {
                    submenuFilter.push(k);
                  }
                  else
                  {
                    stillValid = false; // the whole topic is not longer valid
                  }
                }
              }
              if ( this.baseFilters[i].submenu.length == submenuFilter.length ) // used up all the submenus
              {
                stillValid = false; // the whole topic is not longer valid
              }
            }
          }
        }
      
      if ( stillValid == true )
      {
        if ( submenuFilter.length == 0 ) {
          if(this.baseFilters[i].hasInputMenuItems) {
            for ( var k = 0; k < this.baseFilters[i].submenu.length; k++ ) {
              this.resetInputMenuItem(this.baseFilters[i].submenu[k]);
            }
          }
          this.availableFilters.push(this.baseFilters[i]);
        }
        else
        {
          let tempFilter = _.cloneDeep(this.baseFilters[i]);
          // only unchosen submenu items are still valid
          let tempSubMenus = new Array<GenericFilterMenu>();
          for ( var k = 0; k < this.baseFilters[i].submenu.length; k++ )
          {
            if ( submenuFilter.indexOf(k) == -1 ) {
              this.resetInputMenuItem(this.baseFilters[i].submenu[k]);
              tempSubMenus.push(_.cloneDeep(this.baseFilters[i].submenu[k]));
            }
          }
          tempFilter.submenu = tempSubMenus;
          this.availableFilters.push(tempFilter);
        }
      }
    }
    this.showMenu = true;
  }

  resetInputMenuItem(item: GenericFilterMenu) {
    if ( item.data.style == 'input' ) {
      item.displayStr = undefined;
      item.data.value = undefined;
      item.data.control.reset();
    }
  }

  checkIfSearchIsAllowed() {
    if (this.config?.textSearch && this.selectedFilters && this.selectedFilters.length > 0) {
      let searchAllowed = true;
      for (var i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].originalItem.incompatibleWith == 'textSearch') {
          searchAllowed = false;
          break;
        }
      }
      if (!searchAllowed) {
        this.searchParams.searchText = undefined;
        this.searchTerm = undefined;
        this.textSearchDisabled = true;
      } else if (this.textSearchDisabled) {
        this.textSearchDisabled = false;
      }
    } else if (this.textSearchDisabled) {
      this.textSearchDisabled = false;
    }
  }

  getFirstValidatorErrorAlert(itemData: any) {
    let errors = itemData.control?.errors;
    let firstError = errors ? Object.keys(errors)[0] : undefined;
    if (firstError && !(_.isEmpty(itemData.validationAlerts)) && (firstError in itemData.validationAlerts)) {
        return itemData.validationAlerts[firstError];
    }
    return undefined;
  }

  createFilterParamsAndEmit()
  {
    // create the filter params and emit them
    this.selectedFilterParams = undefined;
    this.selectedFilterParams = new GenericItemSearchParams();

    if ( this.selectedFilters && this.selectedFilters.length > 0)
    {
      this.selectedFilterParams.filterData = new Array<any>();
      for ( var i = 0; i < this.selectedFilters.length; i++ )
        this.selectedFilterParams.filterData.push(this.selectedFilters[i].data);
    }
    console.log("emitting ", this.selectedFilterParams )
    this.searchParams.filterData = this.selectedFilterParams.filterData;
    this.searchParamsChange.emit(this.searchParams);
  }

  generateFilterData( selFilters: FilterItem[] ): any[]
  {
    let filterData = new Array<any>();
    for ( var i = 0; i < selFilters.length; i++ )
    {
      if (selFilters[i].data != undefined )
        filterData.push(selFilters[i].data);
    }

    return filterData;
  }

  async onRemoveInProgressFilter()
  {
    if ( this.filterInProgress && this.filterInProgress.originalItem.componentBased && this.filterComponent.length > 0 )
    {
        this.filterComponent.remove(0);
        if ( this.componentEventSub )
          this.componentEventSub.unsubscribe();
    }
    this.currentMenu = undefined;
    this.filterInProgress = undefined;
    this.filterMenuTrigger.closeMenu();
    await this.resetAvailableFilters();
  }

  async onRemoveFilter(filter)
  {
    // if anything is removed, the menu starts over at the beginning. 
    // Any filter Inprogress is removed as well
    console.log("This is the available filters", this.availableFilters)
    console.log("There are the selected filters", this.selectedFilters);
    console.log("These are the base filters", this.baseFilters)
    let tempItems = new Array<FilterItem>();
    for ( var i = 0; i < this.selectedFilters.length; i++ )
    {
      if ( this.selectedFilters[i].id != filter.id &&
         ((this.selectedFilters[i].originalItem.prerequisite == undefined) || 
         (this.selectedFilters[i].originalItem.prerequisite && this.selectedFilters[i].originalItem.prerequisite != filter.id)) &&
         (this.filterInProgress == undefined || (this.selectedFilters[i].id != this.filterInProgress.id)) )
      {
        tempItems.push( this.selectedFilters[i]) ;
      }
    }
    this.selectedFilters = tempItems;
    if ( this.filterInProgress && this.filterInProgress.originalItem.componentBased && this.filterComponent.length > 0 )
    {
        this.filterComponent.remove(0);
        if ( this.componentEventSub )
          this.componentEventSub.unsubscribe();
    }
    this.currentMenu = undefined;
    this.filterInProgress = undefined;
    await this.resetAvailableFilters();
    this.checkIfSearchIsAllowed();
    this.createFilterParamsAndEmit();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if ( this.componentEventSub )
      this.componentEventSub.unsubscribe();
  }
}



